/** Typy obtiaznosti pre appku wsm 2021 */
export var AppWSM2021DifficultyTypes;
(function (AppWSM2021DifficultyTypes) {
    AppWSM2021DifficultyTypes[AppWSM2021DifficultyTypes["easy"] = 11] = "easy";
    AppWSM2021DifficultyTypes[AppWSM2021DifficultyTypes["medium"] = 12] = "medium";
    AppWSM2021DifficultyTypes[AppWSM2021DifficultyTypes["hard"] = 13] = "hard";
})(AppWSM2021DifficultyTypes || (AppWSM2021DifficultyTypes = {}));
//# sourceMappingURL=appWSM2021.js.map